module.exports = __webpack_public_path__ + "static/img/1_14.83daa4c5.jpg";